import { useState } from "react";
import { motion } from "framer-motion";
import Corners from "./Corners";

const YT_ID = "uyyv0pJUmJo";
const POSTER = `https://i.ytimg.com/vi/${YT_ID}/maxresdefault.jpg`;
const POSTER_FALLBACK = `https://i.ytimg.com/vi/${YT_ID}/hqdefault.jpg`;

export default function VslPlayer({ className = "", maxWidth = 880, meta = "WAM · OVERVIEW / 03:42" }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className={`relative mx-auto w-full ${className}`} style={{ maxWidth }}>
      <div className="relative aspect-video w-full overflow-hidden border border-[#C9A84C]/35 bg-black shadow-[0_40px_120px_-20px_rgba(0,0,0,0.9)]">
        <Corners />
        {playing ? (
          <iframe
            title="WAM VSL"
            src={`https://www.youtube.com/embed/${YT_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
            className="absolute inset-0 h-full w-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="vsl-iframe"
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            data-testid="vsl-play-btn"
            className="group absolute inset-0 block w-full cursor-pointer"
            aria-label="Play video"
          >
            <img
              src={POSTER}
              onError={(e) => {
                e.currentTarget.src = POSTER_FALLBACK;
              }}
              alt="WAM overview"
              className="h-full w-full object-cover"
              style={{ filter: "brightness(0.72) contrast(1.05) saturate(0.9)" }}
            />
            <div
              aria-hidden
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "radial-gradient(60% 50% at 50% 50%, transparent 30%, rgba(7,7,9,0.6) 85%)",
              }}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <motion.div
                whileHover={{ scale: 1.06 }}
                transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                className="relative flex h-[74px] w-[74px] md:h-[104px] md:w-[104px] items-center justify-center rounded-full bg-[#C9A84C] shadow-[0_20px_80px_-10px_rgba(201,168,76,0.6)]"
              >
                <span
                  className="absolute inset-0 rounded-full border border-[#C9A84C]/50 animate-ping"
                  style={{ animationDuration: "3s" }}
                />
                <svg
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                  className="translate-x-[3px]"
                  fill="#070709"
                  aria-hidden
                >
                  <path d="M6 4l14 8-14 8V4z" />
                </svg>
              </motion.div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between border-t border-[#C9A84C]/20 bg-gradient-to-t from-[#070709] via-[#070709]/85 to-transparent px-4 py-3 font-mono text-[9px] tracking-[0.3em] text-[#F0ECE4]/70">
              <span>{meta}</span>
              <span className="text-[#C9A84C] transition-transform group-hover:translate-x-1">
                PLAY →
              </span>
            </div>
          </button>
        )}
      </div>
    </div>
  );
}
